import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'app-page-section',
  imports: [],
  templateUrl: './page-section.html',
  host: {
    class: 'block flex-1 min-w-0',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageSection {
  readonly center = input(false);
  readonly background = input('');
}
